import { createFederationRef, readonlyFederationRef } from "@constructor/federation-common/base";
function createFederationRootDataFabric() {
  const dataRefs = /* @__PURE__ */ new Map();
  const instances = /* @__PURE__ */ new Set();
  return {
    setDataGetter,
    createRootDataService
  };
  function setDataGetter(key, value) {
    dataRefs.set(key, value);
    instances.forEach((instance) => instance.notify(key));
  }
  function createRootDataService() {
    const subscribers = /* @__PURE__ */ new Map();
    const instance = {
      notify: (key) => {
        var _a;
        (_a = subscribers.get(key)) == null ? void 0 : _a.forEach((callback) => callback());
      }
    };
    instances.add(instance);
    return {
      createDataAccessor,
      destroy: () => {
        instances.delete(instance);
        subscribers.clear();
      }
    };
    function createDataAccessor(key) {
      if (!dataRefs.has(key)) {
        throw new Error(`Data key "${key}" is not set in root application`);
      }
      const data = createFederationRef(void 0);
      const initialValue = dataRefs.get(key);
      data.set(initialValue);
      function callback() {
        const newValue = dataRefs.get(key);
        data.set(newValue);
      }
      if (!subscribers.has(key)) {
        subscribers.set(key, /* @__PURE__ */ new Set());
      }
      subscribers.get(key).add(callback);
      return {
        data: readonlyFederationRef(data)
      };
    }
  }
}
export {
  createFederationRootDataFabric as c
};
//# sourceMappingURL=rootData.js.map
